export const STUDENTS_FEATURE_KEY = 'admin-students';
